
const contactForm = {
  'contactMe.header': 'Bekleyemiyorum, benimle iletişime geçin!',
  'contactMe.instructions': 'Temsilcilerimizin sizinle iletişime geçebilmesi için lütfen aşağıdaki formu doldurun.',
  'contactMe.name': 'Ad',
  'contactMe.lastName': 'Soyad',
  'contactMe.email': 'E-posta (isteğe bağlı)',
  'contactMe.country': 'Ülke',
  'contactMe.whatsappNumber': 'WhatsApp Numarası',
  'contactMe.countryCode': 'Ülke kodu',
  'contactMe.language': 'Tercih Edilen Dil',
  'contactMe.message': 'Mesaj (isteğe bağlı)',
  'contactMe.submit': 'Gönder',
  'contactMe.submitting': 'Gönderiliyor...',
  'contactMe.success.title': 'Bizimle iletişime geçtiğiniz için teşekkürler!',
  'contactMe.success.message': 'Bilgileriniz başarıyla gönderildi. The Club\'dan bir temsilci en kısa sürede sizinle iletişime geçecektir.',
  'contactMe.placeholders.name': 'Adınızı girin',
  'contactMe.placeholders.lastName': 'Soyadınızı girin',
  'contactMe.placeholders.email': 'E-postanızı girin',
  'contactMe.placeholders.country': 'Ülkenizi seçin',
  'contactMe.placeholders.countryCode': 'Kod',
  'contactMe.placeholders.whatsappNumber': 'WhatsApp numarası',
  'contactMe.placeholders.language': 'Tercih ettiğiniz dil',
  'contactMe.placeholders.message': 'Mesajınızı buraya yazın',
  'contactMe.errors.name': 'Ad zorunludur',
  'contactMe.errors.lastName': 'Soyad zorunludur',
  'contactMe.errors.email': 'Geçersiz e-posta adresi',
  'contactMe.errors.country': 'Ülke zorunludur',
  'contactMe.errors.countryCode': 'Ülke kodu zorunludur',
  'contactMe.errors.whatsappNumber': 'WhatsApp numarası zorunludur',
  'contactMe.errors.language': 'Dil zorunludur',
  'contactMe.errors.messageMaxLength': 'Mesaj {max} karakteri aşamaz',
  'contactMe.errors.submission': 'Form gönderimi başarısız oldu',
  'contactMe.errors.generic': 'Bir şeyler ters gitti. Lütfen tekrar deneyin.',
  'contactMe.page.title': 'Herkesten Önce Kazanmaya Başlayın',
};

export default contactForm;
